<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="AddJobTitle" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="名称" prop="PaJobTitle.name">
            <el-input class="input-item" v-model="formData.PaJobTitle.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaJobTitle.type!=='group'">
          <el-form-item label="级别" prop="PaJobTitle.levelCode">
            <el-select class="input-item" v-model="formData.PaJobTitle.levelCode" :clearable="true" filterable
              placeholder="级别" :loading="AddJobTitle.levelCode.impl.loading"
              @visible-change="AddJobTitle.levelCode.impl.onVisibleChange"
              @change="onLevelCodeValueChange">
              <el-option v-for="item in AddJobTitle.levelCode.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaJobTitle.type!=='group'">
          <el-form-item label="津贴" prop="PaJobTitle.allowance">
            <el-input-number class="input-item" v-model="formData.PaJobTitle.allowance"
              :clearable="true"
              placeholder="职称津贴(元)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="PaJobTitle.detail">
            <el-input class="input-item" v-model="formData.PaJobTitle.detail"
              :clearable="true" placeholder="描述"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaJobTitle.remark">
            <el-input class="input-item" v-model="formData.PaJobTitle.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="排序" prop="PaJobTitle.sort">
            <el-input-number class="input-item" v-model="formData.PaJobTitle.sort"
              :clearable="true"
              placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('AddJobTitle:AddJobTitle:add')"
              @click="onAddClick()">
              新增
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaJobTitleController, DictionaryController } from '@/api';

export default {
  name: 'AddJobTitle',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    pid: {
      default: undefined
    },
    type: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        PaJobTitle: {
          id: undefined,
          pid: this.pid,
          type: this.type,
          code: undefined,
          gcode: undefined,
          name: undefined,
          levelCode: undefined,
          detail: undefined,
          allowance: 0,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sort: 1,
          sysUser: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'PaJobTitle.allowance': [
          {required: true, message: '请输入津贴', trigger: 'blur'},
          {type: 'number', message: '津贴只允许输入数字', trigger: 'blur', transform: (value) => Number(value)}
        ],
        'PaJobTitle.sort': [
          {type: 'integer', message: '排序只允许输入整数', trigger: 'blur', transform: (value) => Number(value)}
        ],
        'PaJobTitle.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ]
      },
      AddJobTitle: {
        formFilter: {
        },
        formFilterCopy: {
        },
        levelCode: {
          impl: new DropdownWidget(this.loadLevelCodeDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 级别下拉数据获取函数
     */
    loadLevelCodeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_job_title_level'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 级别选中值改变
     */
    onLevelCodeValueChange (value) {
    },
    /**
     * 更新添加职称
     */
    refreshAddJobTitle (reloadData = false) {
      if (!this.AddJobTitle.isInit) {
        // 初始化下拉数据
      }
      this.AddJobTitle.isInit = true;
    },
    /**
     * 新增
     */
    onAddClick () {
      this.$refs.AddJobTitle.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            levelCodeDictMap: findItemFromList(this.AddJobTitle.levelCode.impl.dropdownList, this.formData.PaJobTitle.levelCode, 'id'),
            ...this.formData.PaJobTitle
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          paJobTitleDto: {
            sort: this.formData.PaJobTitle.sort,
            pid: this.pid,
            type: this.formData.PaJobTitle.type,
            code: this.formData.PaJobTitle.code,
            gcode: this.formData.PaJobTitle.gcode,
            name: this.formData.PaJobTitle.name,
            levelCode: this.formData.PaJobTitle.levelCode,
            detail: this.formData.PaJobTitle.detail,
            allowance: this.formData.PaJobTitle.allowance,
            remark: this.formData.PaJobTitle.remark
          }
        };

        PaJobTitleController.add(this, params).then(res => {
          this.$message.success('新增成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaJobTitle: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          levelCode: undefined,
          detail: undefined,
          allowance: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sort: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshAddJobTitle();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaJobTitle = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
